<template>
    <div :class="'alert t-alert alert-' + type" :show="haveMessages">
        <button type="button" aria-label="Close" class="close" slot="dismiss" v-if="closeable">
            <i class="fal fa-times fa-fw"></i>
        </button>
        <div class="alert-contents d-flex align-items-center">
            <slot name="icon">
                <i class="fa fa-exclamation-triangle mr-3" v-if="type === 'danger'"></i>
                <span class="fa-stack fa-xs mr-3" v-if="type === 'success'">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa fa-check fa-inverse fa-stack-1x"></i>
                </span>
            </slot>
            <ul class="list-unstyled" v-if="haveMessages">
                <li v-for="(m, k) in messages" :key="k">
                    {{ m }}
                </li>
            </ul>
            <slot></slot>
            <div class="alert-link ml-auto align-self-center">
                <slot name="link"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        closeable: {
            type: Boolean,
            default: false,
        },
        message: {},
    },
    computed: {
        haveMessages() {
            return _.isArray(this.messages) && !_.isEmpty(this.messages);
        },
        messages() {
            return _.isArray(this.message) ? this.message : [this.message];
        },
    },
};
</script>

<style>
.t-alert {
    border-radius: 3px;
}

.t-alert ul {
    margin-bottom: 0;
}

.t-alert .alert-link a {
    color: inherit !important;
    text-transform: uppercase;
    text-decoration: underline;
}

.t-alert .fa-border {
    border-color: #147249;
}
</style>
